import React from 'react';

import { DownstreamOwnerIdsFilteredByFieldQuery, DownstreamOwnerIdsFilteredByFieldQueryVariables, OwnerIdFragment, WorkbookDownstreamOwnerIdsQuery, WorkbookDownstreamOwnerIdsQueryVariables , DownstreamOwnerIdsFilteredByFieldDocument , WorkbookDownstreamOwnerIdsDocument } from '../../../../../gen-src/queries';
import {
  ComposeEmailPaneButton,
  DataCatalogApolloClient,
  getAllFromSliceable,
  GraphQLSliceable,
  HorizontalFlexContainer,
  MultiSelectionProvider,
  PaneTitle,
  Sliceable,
  VerticalFlexContainer
} from '../../../data-catalog-shared';
import { OwnersGridSortProvider } from '../sorting/sortProviders/OwnersGridSortProvider';
import { MultiSelectionControls } from '../widgets/MultiSelectionControls';
import { WorkbookDownstreamOwnersQueryGrid } from './WorkbookDownstreamOwnersQueryGrid';

export interface WorkbookDownstreamOwnersPaneProps {
  readonly title: string;
  readonly vizportalUrlId: string;
  readonly filteredFieldId: string | null;
  readonly rowCount: number | null;
  readonly workbookLuid: string;
}

export class WorkbookDownstreamOwnersPane extends React.Component<WorkbookDownstreamOwnersPaneProps> {

  public override render(): JSX.Element {
    return (
      <MultiSelectionProvider selectionId={this.props.vizportalUrlId}>
        {({ selectedKeys, setSelectedKeys, updateSelectionForKey }) =>
          <VerticalFlexContainer fillFlexParent={true}>
            <PaneTitle>
              <HorizontalFlexContainer>
                {this.props.title}
                {this.props.rowCount != null && this.props.rowCount > 0 ?
                  <>
                    <MultiSelectionControls
                      selectedKeys={selectedKeys}
                      setSelectedKeys={setSelectedKeys}
                      updateSelectionForKey={updateSelectionForKey}
                      fetchAllKeys={this.fetchAllOwnerKeys}
                    />
                    <ComposeEmailPaneButton
                      selectedUserIds={selectedKeys}
                      contentType='workbook'
                      contentId={this.props.vizportalUrlId}
                      contentLuid={this.props.workbookLuid}
                    />
                  </>
                  : null
                }
              </HorizontalFlexContainer>
            </PaneTitle>
            <OwnersGridSortProvider>
              {({ orderBy, updateSortOrder }) =>
                <WorkbookDownstreamOwnersQueryGrid
                  vizportalUrlId={this.props.vizportalUrlId}
                  selectedKeys={selectedKeys}
                  updateSelectionForKey={updateSelectionForKey}
                  filteredFieldId={this.props.filteredFieldId}
                  rowCount={this.props.rowCount}
                  orderBy={orderBy}
                  updateSortOrder={updateSortOrder}
                />
              }
            </OwnersGridSortProvider>
          </VerticalFlexContainer>
        }
      </MultiSelectionProvider>
    );
  }

  private readonly fetchAllOwnerKeys = async (client: DataCatalogApolloClient): Promise<ReadonlyArray<string>> => {
    const sliceable = this.createOwnerIdsSliceable(client);
    const items = await getAllFromSliceable(sliceable);
    return items.map(item => item.vizportalId);
  }

  private createOwnerIdsSliceable(client: DataCatalogApolloClient): Sliceable<OwnerIdFragment> {
    if (this.props.filteredFieldId) {
      return new GraphQLSliceable<
        OwnerIdFragment,
        OwnerIdFragment,
        DownstreamOwnerIdsFilteredByFieldQueryVariables,
        DownstreamOwnerIdsFilteredByFieldQuery
      >({
        queryGql: DownstreamOwnerIdsFilteredByFieldDocument,
        selectConnectionListResult: (resultData) => {
          const field = resultData.fields && resultData.fields[0];
          return field.downstreamOwnersConnection;
        },
        mapResultNode: (node) => node,
      }, { fieldId: this.props.filteredFieldId }, client);
    } else {
      return new GraphQLSliceable<
        OwnerIdFragment,
        OwnerIdFragment,
        WorkbookDownstreamOwnerIdsQueryVariables,
        WorkbookDownstreamOwnerIdsQuery
      >({
        queryGql: WorkbookDownstreamOwnerIdsDocument,
        selectConnectionListResult: (resultData) => {
          const workbook = resultData.workbooks && resultData.workbooks[0];
          return workbook.downstreamOwnersConnection;
        },
        mapResultNode: (node) => node,
      }, { WorkbookVizportalUrlId: this.props.vizportalUrlId }, client);
    }
  }

}
